import React, { useContext, useEffect, useState } from "react";
import { Container } from "components/Container";
import { useHistory } from "react-router";
import * as atoms from "./CrearPerfilStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import {PerfilRegistro} from "./perfil-registro";
import PerfilService from "services/PerfilService";
import { notification } from "antd";

const CrearPerfilPage = () =>{
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [perfilAtom]=useAtom(atoms.perfil);
    const cerrarModalConfirmacion = useModalConfirmar(state => state.cerrarModal);

    const onClickRetornarListarPerfiles=()=>{
        history.push("/perfil");
    }
    const onClickBtnCancelarModal=()=>{
        cerrarModalConfirmacion();
    }
    const onClickBtnConfirmarModal = async ()=>{
        try {
            setLoading(true);
            const _perfil= await PerfilService.insertar(perfilAtom);
            setLoading(false);
            cerrarModalConfirmacion();
            history.push("/perfil");
            
        } catch (error) {
            console.error(error);
            cerrarModalConfirmacion();
            notification.error({
                message:"Error",
                description:error.response.data.mensaje});
            
        }finally{
            setLoading(false);
        }

    }
    return(
        <Container titulo="Crear Perfil" onClickRetornar={onClickRetornarListarPerfiles}>
         <PerfilRegistro/>
         <ModalConfirmar
                loading={loading}
                mensaje="¿Está seguro de guardar el Perfil? "
                onClickBtnCancelar={onClickBtnCancelarModal}
                onClickBtnConfirmar={onClickBtnConfirmarModal} />
        </Container>
    )

}
export default CrearPerfilPage;